<h2 class="mat-display-2 mt-4 mb-2 ta-c">{{ message }}</h2>
<mat-spinner diameter="80"></mat-spinner>